import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { BrandMark } from '@/components/Brand'
import { useAuth } from '@/contexts/AuthContext'
import type { UserRole } from '@/types'

export function AppSplash() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-cream" role="status" aria-label="Cargando aplicación">
      <BrandMark className="h-14 w-14 animate-pulse rounded-2xl" />
      <div className="h-1 w-24 overflow-hidden rounded-full bg-forest-100">
        <div className="h-full w-1/2 animate-pulse rounded-full bg-forest-600" />
      </div>
    </div>
  )
}

export function ProtectedRoute({ role, children }: { role: UserRole; children: ReactNode }) {
  const { profile, loading } = useAuth()
  const location = useLocation()
  if (loading) return <AppSplash />
  if (!profile) return <Navigate to="/login" replace state={{ from: location, message: 'Debes iniciar sesión para acceder.' }} />
  if (!profile.active) return <Navigate to="/login" replace state={{ message: 'Tu cuenta se encuentra deshabilitada.' }} />
  if (profile.role !== role) return <Navigate to={profile.role === 'admin' ? '/admin' : '/dashboard'} replace />
  return children
}

export function HomeRedirect() {
  const { profile, loading } = useAuth()
  if (loading) return <AppSplash />
  if (!profile) return <Navigate to="/login" replace />
  return <Navigate to={profile.role === 'admin' ? '/admin' : '/dashboard'} replace />
}
